/**
 * Scroll so a vertical span (start top → end bottom) sits in the visible area
 * between the fixed header and the bottom nav.
 * If the span fits, the start is pinned under the header.
 * If it is taller than the screen, the end is pinned above the bottom nav.
 *
 * @param {number} startTop
 * @param {number} endBottom
 * @param {number} viewTop
 * @param {number} viewBottom
 */
export function computeScrollDelta({ startTop, endBottom, viewTop, viewBottom }) {
  const span = endBottom - startTop;
  const viewHeight = viewBottom - viewTop;
  if (span <= viewHeight) return startTop - viewTop;
  return endBottom - viewBottom;
}

function chromeInsets() {
  const shell = document.querySelector("[data-testid='platform-app-shell']");
  const styles = getComputedStyle(shell || document.documentElement);
  const header = parseFloat(styles.getPropertyValue("--tra-shell-header-h")) || 64;
  const bottomBar = parseFloat(styles.getPropertyValue("--tra-shell-bottom-h")) || 72;
  const bottom = window.innerWidth >= 768 ? 0 : bottomBar;
  const pad = 12;
  return {
    viewTop: header + pad,
    viewBottom: window.innerHeight - bottom - pad,
  };
}

function scrollParent(el) {
  let node = el.parentElement;
  while (node && node !== document.body) {
    const overflowY = getComputedStyle(node).overflowY;
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      node.scrollHeight > node.clientHeight + 1
    ) {
      return node;
    }
    node = node.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

/**
 * @param {Element | null | undefined} startEl
 * @param {Element | null | undefined} endEl
 */
export function scrollSpanIntoView(startEl, endEl) {
  if (!startEl || !endEl || typeof window === "undefined") return;
  const { viewTop, viewBottom } = chromeInsets();
  const startTop = startEl.getBoundingClientRect().top;
  const endBottom = endEl.getBoundingClientRect().bottom;
  const delta = computeScrollDelta({ startTop, endBottom, viewTop, viewBottom });
  if (Math.abs(delta) < 2) return;
  const scroller = scrollParent(startEl);
  if (scroller === document.scrollingElement || scroller === document.documentElement || scroller === document.body) {
    window.scrollBy({ top: delta, behavior: "smooth" });
    return;
  }
  scroller.scrollBy({ top: delta, behavior: "smooth" });
}
